<p-dialog
  class="duplicate-patients-dialog"
  [(visible)]="visible"
  [modal]="true"
  appendTo="body"
  [blockScroll]="false"
  [closable]="true"
  (onHide)="onDialogClosed()"
  [style]="{'width': '980px', 'max-height': '650px', 'overflow-x': 'auto' }"
  header="DUPLICATE PATIENTS"
>
  <ng-container *ngIf="_currentPatient">
    <div class="header-pill p-d-flex p-ai-center p-jc-between p-p-3 p-mb-4">
        <div class="patient-info p-d-flex p-ai-center">
          <div class="details-grid">
            <div class="avatar-name">
            <p-avatar
              [label]="_currentPatient.firstName?.charAt(0) + _currentPatient.lastName?.charAt(0)"
              size="large"
              styleClass="mr-2"
              [style]="{ 'background-color': '#0EDE99', width: '29px', height: '29px', color: 'black',  'font-size': '11px', 'font-weight': 600}"
              shape="circle"
            ></p-avatar>
            <div>
              <small class="label">First name</small><br />
              <span class="value">{{ _currentPatient.firstName }}</span>
            </div>
          </div>
            <div>
              <small class="label">Last name</small><br />
              <span class="value">{{ _currentPatient.lastName }}</span>
            </div>
            <div>
              <small class="label">Date of birth</small><br />
              <span class="value">{{ _currentPatient.dateOfBirth | date:'dd/MM/yyyy' }}</span>
            </div>
            <div>
              <small class="label">Sex</small><br />
              <span class="value">{{ GenderMap[_currentPatient.gender] }}</span>
            </div>
            <div>
              <small class="label">Groups</small><br />
              <span class="value">

                  <ng-container *ngIf="!!firstGroupName()">
                    <span
                      [pTooltip]="!!firstGroupName() ? overflowTooltip : null"
                      tooltipPosition="bottom"
                      [tooltipStyleClass]="'custom-overlaypanel'"
                      [escape]="false"
                    >
                      {{ firstGroupName() }}
                      <span *ngIf="overflowCount > 0" style="color: #6F919D"> +{{ overflowCount }} </span>
                    </span>
                  </ng-container>
              </span>
            </div>
          </div>
        </div>
      </div>
  </ng-container>
<div class="description-buttons">
  <p class="description">
    We found a few patients that match the information you entered. How would you like to proceed?
  </p>

  <div class="mode-select p-formgroup-inline p-ml-4">
    <div class="radio-button-select">
      <p-radioButton
      name="dupMode"
      value="create"
      [(ngModel)]="mode"
      (onClick)="onModeChange('create')"
      ></p-radioButton>
      <label for="dupMode">Create a new patient</label>
    </div>
    <div class="radio-button-select">
      <p-radioButton
      name="dupMode"
      value="select"
      [(ngModel)]="mode"
      (onClick)="onModeChange('select')"
      ></p-radioButton>
      <label for="dupMode">Select from existing patients</label>
    </div>
  </div>
</div>
  <div class="dialog-body-scroll">
    <div class="patient-grid card main-container">
      <grid
      [tableSettings]="tableSettings"
      [gridSettings]="gridSettings"
      [(selection)]="selectedPatient">

      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="tableSettings.columns.length">
            <medical-record-empty-list
              [loading]="false"
              [secondaryEmptyMessage]="secondaryEmptyMessage"
              [recordsCount]="0"
              [restrictedReason]="restrictedNhsReason">
            </medical-record-empty-list>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="loadingbody">
        <tr>
          <td [attr.colspan]="tableSettings.columns.length">
            <medical-record-empty-list [loading]="true"></medical-record-empty-list>
          </td>
        </tr>
      </ng-template>
    </grid>

    <div *ngIf="mode === 'create'"
        class="grid-overlay"></div>
  </div>
</div>
  <ng-template pTemplate="footer">
      <hr class="bottom-line">
    <div class="dialog-footer p-d-flex p-jc-end p-px-4 p-py-2">
      <button 
        pButton 
        label="Cancel" 
        class="select-link p-button-text p-button-plain" 
        (click)="cancel()"
        [disabled]="saving"></button>
      <button
        pButton
        label="Continue"
        class="p-element m-button-primary mb-1 p-button p-component ng-star-inserted"
        (click)="continue()"
        [disabled]="!canContinue()"
        [loading]="saving"
      ></button>
    </div>
  </ng-template>
</p-dialog>

<merge-patient-dialog
  [(visible)]="mergePatientDialogVisible"
  [parentId]="mergeParentId"
  [childId]="mergeChildId"
  (mergeConfirmed)="onMergePatientDialogClose($event)"></merge-patient-dialog>